import { isNull } from 'lodash';

const isDefinedFilter = <T>(value: T): value is Exclude<T, undefined | null> => (
  value !== undefined && !isNull(value)
);

export default isDefinedFilter;
